var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#633806",
    d: "M12.987 5.74a2 2 0 1 0-1.97.002l-.01.018c-.655 1.367-1.565 3.325-2.97 4.06c-1.154.603-2.81.3-4.04.074a1.5 1.5 0 1 0-1.772 1.58l2.948 7.61A3 3 0 0 0 7.97 21h8.06a3 3 0 0 0 2.797-1.916l2.947-7.61a1.5 1.5 0 1 0-1.767-1.624c-1.259.163-2.882.371-4.044-.236c-1.377-.72-2.3-2.543-2.976-3.874m-.962 2.367c.768 1.246 1.689 2.587 3.012 3.28c1.327.693 2.96.658 4.42.533l-2.495 6.441a1 1 0 0 1-.932.639H7.97a1 1 0 0 1-.932-.639l-2.461-6.353c1.439.184 3.067.274 4.386-.416c1.378-.72 2.3-2.172 3.062-3.485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipIcon);
export default __webpack_public_path__ + "static/media/vip-icon.6f57319201a8dbb9fce5cce809ee61a8.svg";
export { ForwardRef as ReactComponent };